var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterXDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3347 26.6298L12.501 14.4104H20.2899L26.3602 21.9629L32.8453 14.4444H37.1351L28.4343 24.5434L38.751 37.3792H30.9853L24.4124 29.2116L17.3952 37.3565H13.0822L22.3347 26.6298ZM32.1172 35.1151L17.2769 16.6744H19.1572L33.9787 35.1151H32.1172Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterXDark);
export default __webpack_public_path__ + "static/media/twitterX-dark.f0172e5c7226db854fc76c57af0520b6.svg";
export { ForwardRef as ReactComponent };